module.exports = __webpack_public_path__ + "img/ic-featured-inactive.23b63c7e.svg";